import axios from "axios";
import { getToken, getCookie } from "../cookies";

// export const BASE_URL = "http://localhost:1337";
export const BASE_URL = "https://api.drivewithdio.com";
const appType = getCookie('appType')

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "X-App-Type": appType ?? "teacher",
        "Cache-Control": "no-cache",
        "X-Platform": "TeacherWeb",
    },
});

// Add a request interceptor to include the token if it exists
api.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

export default api; 